import { TAcList } from './Account.interface';
import { Product } from './ProductItem';
//import { Product } from "./ProductItem";
export interface TrnMain {
  Mode: string;
  NextVno: string;
  TotalWithIndDiscount: number;
  guid: string;
  ReplaceIndividualWithFlatDiscount: number;
  TOTALINDDISCOUNT: number;
  TOTALLOYALTY: number;
  TOTALPROMOTION: number;
  TOTALFLATDISCOUNT: number;
  COSTCENTER: string;
  RECEIVEBY: string;
  STATUS: number;
  CONFIRMEDBY: string;
  CONFIRMEDTIME: string;
  PhiscalID: string;
  Stamp: number;
  Customer_Count: number;
  DBUSER: string;
  HOSTID: string;
  ORDERS: number;
  REFORDBILL: string;
  INDDIS: number;
  CREBATE: number;
  CREDIT: number;
  DUEDATE: Date;
  TRNAC: string;
  PARAC: string;
  PARTRNAMNT: number;
  RETTO: string;
  REFBILL: string;
  CHEQUENO: string;
  CHEQUEDATE: Date;
  EDATE: Date;
  POST: number;
  POSTUSER: string;
  FPOSTUSER: string;
  SHIFT: string;
  EXPORT: number;
  CHOLDER: string;
  CARDNO: string;
  EditUser: string;
  MEMBERNO: string;
  MEMBERNAME: string;
  EDITED: number;
  VMODE: number;
  BILLTOTEL: string;
  BILLTOMOB: string;
  TRN_DATE: Date;
  BS_DATE: string;
  STAX: number;
  TOTALCASH: number;
  TOTALCREDIT: number;
  TOTALCREDITCARD: number;
  TOTALGIFTVOUCHER: number;
  CardTranID: string;
  ReturnVchrID: string;
  TranID: number;
  VoucherStatus: string;
  PRESCRIBEBY: string;
  DISPENSEBY: string;
  Longitude: string;
  Latitude: string;
  MobileNo: string;
  DeliveryDate: Date;
  DeliveryAddress: string;
  DeliveryTime: string;
  DeliveryMiti: string;
  OrderNo: string;
  ADJWARE: string;
  BATCHNO: string;
  BATCHNAME: string;
  DPSNO: string;
  EDITTIME: string;
  EID: string;
  EXTRACHARGE: string;
  ISSUEWARE: string;
  ADVANCE: number;
  VoucherType: VoucherTypeEnum;
  VoucherAbbName: string;
  VoucherName: string;
  VoucherPrefix: string;
  NextNumber: number;
  SalesManID: string;
  VCHRNO: string;
  CHALANNO: string;
  DIVISION: string;
  TRNDATE: Date;
  BSDATE: string;
  TRNTIME: string;
  TOTAMNT: number;
  DCAMNT: number;
  DCRATE: number;
  VATAMNT: number;
  NETAMNT: number;
  TRNMODE: string;
  TAXABLE: number;
  NONTAXABLE: number;
  BILLTO: string;
  BILLTOADD: string;
  TRNUSER: string;
  TERMINAL: string;
  TENDER: number;
  CHANGE: number;
  ROUNDOFF: number;
  NETWITHOUTROUNDOFF: number;
  ServiceCharge: number;
  IsTable: boolean;
  IsVATBill: boolean;
  VATBILL: number;
  REMARKS: string;
  VoucherNumber: number;
  WAREHOUSE: string;
  TrntranList: Trntran[];
  AdditionTranList: Trntran[];
  ProdList: TrnProd[];
  AdditionProdList: TrnProd[];
  FCurrency: string;
  EXRATE: number;
  TOTALDISCOUNT: number;
  // JOBNO:string;
  vehicleno: string;
  JobCode: string;
  // JOBCODE:string;
  Warranty: boolean;
  Remarks: string;
}
export interface TrnProd {
  Amount: string;
  rate: number;
  qty: number;
  netAmount: number;
  items: any;
  INDDISCOUNT: number;
  FLATDISCOUNT: number;
  NETAMOUNT: number;
  LOYALTY: number;
  PROMOTION: number;
  ISSERVICECHARGE: number;
  ISVAT: number;
  ADDTIONALROW: number;
  COSTCENTER: string;
  VCHRNO: string;
  CHALANNO: string;
  DIVISION: string;
  MCODE: string;
  UNIT: string;
  Quantity: number;
  RealQty: number;
  AltQty: number;
  RATE: number;
  AMOUNT: number;
  DISCOUNT: number;
  VAT: number;
  REALRATE: number;
  EXPORT: number;
  IDIS: string;
  OPQTY: number;
  REALQTY_IN: number;
  ALTQTY_IN: number;
  WAREHOUSE: string;
  REFBILLQTY: number;
  SPRICE: number;
  EXPDATE: Date;
  REFOPBILL: number;
  ALTUNIT: string;
  TRNAC: string;
  PRATE: number;
  VRATE: number;
  ALTRATE: number;
  VPRATE: number;
  VSRATE: number;
  TAXABLE: number;
  NONTAXABLE: number;
  SQTY: number;
  REMARKS: string;
  INVRATE: number;
  EXRATE: number;
  NCRATE: number;
  CRATE: number;
  SNO: number;
  CUSTOM: number;
  WEIGHT: number;
  DRATE: number;
  CARTON: number;
  INVOICENO: string;
  ISSUENO: string;
  BC: string;
  GENERIC: string;
  BATCH: string;
  MFGDATE: Date;
  MANUFACTURER: string;
  SERVICETAX: number;
  BCODEID: number;
  VoucherType: number;
  SALESMANID: number;
  PhiscalID: string;
  STAMP: number;
  ITEMDESC: string;
  DESCA: string;
  MENUCODE: string;
  TOTAL: number;
  Ptype: number;
  Product: Product;
  unitQty: UnitAndQty;
  Mcat: string;
  Mcat1: string;
  ITEMTYPE: string;
  HASITEMTYPE: number;
  RECEIVEDTYPE: string;
  Warranty: number;
  WarrantyStr: string;
}

export interface Trntran {
  ACNAME: string;
  SubledgerTranList: TSubLedgerTran[];
  AccountItem: TAcList;

  VCHRNO: string;
  CHALANNO: string;
  DIVISION: string;
  A_ACID: string;
  DRAMNT: number;
  CRAMNT: number;
  B_ACID: string;
  NARATION: string;
  TOACID: string;
  NARATION1: string;
  VoucherType: VoucherTypeEnum;
  ChequeNo: string;
  ChequeDate: string;
  CostCenter: string;
  MultiJournalSno: number;
  PhiscalID: string;
  SNO: number;
  ROWMODE: string;
  acType: string;
  hasDebit: boolean;
  hasCredit: boolean;
  drBGColor: string;
  crBGColor: string;
  drColor: string;
  crColor: string;
  inputMode: boolean;
  editMode: boolean;
  acitem: any; //to hold the select acount Item value;
}

export interface TSubLedgerTran {
  SNO: number;
  VCHRNO: string;
  CHALANNO: string;
  DIVISION: string;
  A_ACID: string;
  DRAMNT: number;
  CRAMNT: number;
  B_ACID: string;
  NARATION: string;
  TOACID: string;
  VoucherType: VoucherTypeEnum;
  PhiscalID: string;
  MultiJournalSno: number;
  SubledgerItem: TSubLedger;
  ACNAME: string;
  Amount: number;
  ROWMODE: string;
  inputMode: boolean;
  editMode: boolean;
}
export interface TSubLedger {
  SERIAL: number;
  ACID: string;
  ACCODE: string;
  ACNAME: string;
  PARENT: string;
  TYPE: string;
  OPBAL: number;
  MAPID: string;
  IsBasicAc: number;
  ADDRESS: string;
  PHONE: string;
  FAX: string;
  EMAIL: string;
  VATNO: string;
  PType: string;
  CRLIMIT: number;
  CRPERIOD: number;
  SALEREF: number;
  LEVELS: number;
  FLGNEW: number;
  COMMON: number;
  PATH: string;
  INITIAL: string;
}

export interface UnitAndQty {
  Unit: string;
  Qty: number;
  Rate: number;
  BaseUnit: string;
  BaseQty: number;
  BaseRate: number;
  ConversionFactor: number;
}

export interface AlternateUnit {
  SNO: number;
  MCODE: string;
  ALTUNIT: string;
  CONFACTOR: number;
  RATE: number;
  ISDEFAULT: boolean;
  ISDEFAULTPRATE: boolean;
  BRCODE: string;
  RATE_A: number;
  RATE_B: number;
  RATE_C: number;
  RATE_D: number;
  PRATE: number;
  ISDISCONTINUE: number;
}
export interface CostCenter {
  CostCenterName: string;
  DIVISION: string;
  Parent: string;
  TYPE: string;
}

export interface Division {
  INITIAL: string;
  NAME: string;
  REMARKS: string;
  MAIN: string;
  COMNAME: string;
  COMADD: string;
}
export interface Warehouse {
  NAME: string;
  ADDRESS: string;
  PHONE: string;
  REMARKS: string;
  ISDEFAULT: boolean;
  IsAdjustment: number;
  AdjustmentAcc: string;
  ISVIRTUAL: number;
  VIRTUAL_PARENT: string;
  DIVISION: string;
  _id: any;
  // WID: number;
}
// export interface Product{

//     MCODE:string;
//     MENUCODE:string;
//     DESCRIPTION:string;
//     PARENT:string;
// }
export enum VoucherTypeEnum {
  Default = 0,
  Sales = 1,
  SalesReturn = 2,
  Purchase = 3,
  PurchaseReturn = 4,
  StockIssue = 5,
  StockReceive = 6,
  BranchTransferIn = 7,
  BranchTransferOut = 8,
  StockSettlement = 9,
  Stockadjustment = 10,
  Receipe = 11,
  Journal = 12,
  Delivery = 13,
  TaxInvoice = 14,
  CreditNote = 15,
  DebitNote = 16,
  PaymentVoucher = 17,
  ReceiveVoucher = 18,
  PurchaseOrder = 19,
  SalesOrder = 20,
  DeliveryReturn = 21,
  AccountOpeningBalance = 22,
  PartyOpeningBalance = 23,
  OpeningStockBalance = 24,
  SubLedgerOpeningBalance = 25,
  GoodsReceived = 26,
}

export interface VoucherSatus {
  vouchertype: VoucherTypeEnum;
  VCHRNO: string;
  DIVISION: string;
  PhiscalID: string;
  BillMode: string;
}

export interface DialogInfo {
  TRANSACTION: String;
  PARAC: string;
  DIVISION: any;
  DELEVERYLIST: String;
  SALESMODE: String;
  WARRENTYTODATE: Date;
}

export interface IDivision {
  INITIAL: string;
  NAME: string;
  DIVISION: string;
}
